export const PROVINCE = "PROVINCE";
export const PROVINCE_SUCCESS = "PROVINCE_SUCCESS";
export const PROVINCE_FAILED = "PROVINCE_FAILED";
export const PROVINCE_CHECK = "PROVINCE_CHECK";

export const ZONE_LIVESTOCK = "ZONE_LIVESTOCK";
export const ZONE_LIVESTOCK_SUCCESS = "ZONE_LIVESTOCK_SUCCESS";
export const ZONE_LIVESTOCK_FAILED = "ZONE_LIVESTOCK_FAILED";
export const ZONE_LIVESTOCK_CHECK = "ZONE_LIVESTOCK_CHECK";
